module.exports = __webpack_public_path__ + "static/media/other_pages_mobile.822b316d.jpg";